export const formatCouponUsage = (coupon) => {
  const used = coupon?.usedCount || 0;
  if (!coupon?.maxUses) return `${used} (unlimited)`;
  return `${used}/${coupon.maxUses}`;
};

export const isCouponAtLimit = (coupon) => {
  if (!coupon?.maxUses) return false;
  return (coupon.usedCount || 0) >= coupon.maxUses;
};

export const getCouponRedemptionCount = (couponCode, couponRedemptions = []) =>
  couponRedemptions.filter((r) => r.couponCode === couponCode).length;

export const hasUsageCountMismatch = (coupon, redemptionCount) =>
  (coupon?.usedCount || 0) !== redemptionCount;

export const formatCouponAssignError = (error, couponCode, coupons = []) => {
  if (!error) return 'Failed to assign coupon';

  const coupon = coupons.find((c) => c.code === couponCode);
  const usage = coupon ? formatCouponUsage(coupon) : null;

  if (error.includes('maximum uses')) {
    return `Coupon ${couponCode} has reached its limit${usage ? ` (${usage})` : ''}. Open Coupons & Offers → Edit ${couponCode} → clear Max Uses, or reset the usage count to match redemptions.`;
  }

  if (error.includes('already redeemed')) {
    return `This user already has coupon ${couponCode}. Check their redemption history below.`;
  }

  if (error.includes('no longer active')) {
    return `Coupon ${couponCode} is inactive. Activate it under Coupons & Offers first.`;
  }

  if (error.includes('expired')) {
    return `Coupon ${couponCode} has expired. Edit the coupon or create a new one.`;
  }

  return error;
};
